import { createContext } from "react";

export type CustomerInstigator = {
  accountID: string;
  accountNumber: string;
};
export interface IAuthContext {
  token: string;
  sessionId: string;
  instigator: CustomerInstigator;
  authenticated: boolean;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  clearToken: () => void;
}

const AuthContext = createContext<IAuthContext | null>(null);

export default AuthContext;
